// Pull the WordPress data immediately on boot so Redux is never blank
const wpUser = window.wp_user || null;

const initialState = {
  user: wpUser,
  token: wpUser ? 'wordpress_session' : null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_USER':
      return {
        ...state,
        user: payload.user,
        token: payload.token !== undefined ? payload.token : state.token
      };

    case 'CLEAR_USER':
      return {
        ...state,
        user: null,
        token: null
      };

    default:
      return state;
  }
};